var HostedFieldAction;
(function (HostedFieldAction) {
    HostedFieldAction["INPUT"] = "input";
    HostedFieldAction["FOCUS"] = "focus";
    HostedFieldAction["BLUR"] = "blur";
    HostedFieldAction["SUBMIT"] = "submit";
    HostedFieldAction["ERROR"] = "error";
})(HostedFieldAction || (HostedFieldAction = {}));

export { HostedFieldAction };
